import { IconButton, InputAdornment, TextField, Typography, Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";

interface PasswordFieldProps {
  name: string;
  label: string;
  value: string;
  formikError: string | undefined;
  error: boolean | undefined;
  handleChange: (e: React.ChangeEvent<any>) => void;
  touched: boolean | undefined;
  helperText: string;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  name,
  label,
  value,
  error,
  formikError,
  handleChange,
  touched,
  helperText,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <Box sx={{ mb: "20px" }}>
      <TextField
        placeholder={label}
        id={name}
        name={name}
        type={isVisible ? "text" : "password"}
        value={value}
        onChange={handleChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={`toggle ${name} visibility`}
                disableRipple
                onClick={toggleVisibility}
                onMouseDown={(event) => event.preventDefault()}
                tabIndex={-1}
              >
                {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        error={error}
        helperText={helperText}
      />
      {touched && formikError ? (
        <Typography sx={{ pt: "4px" }} variant="caption" color="#fd7b7c">
          {formikError}
        </Typography>
      ) : null}
    </Box>
  );
};

export default PasswordField;
